import React, { useRef, useEffect, useState, useContext } from "react";
import axios from 'axios';
import './Modal.css';
import { Context } from "../../context";
import { ReactComponent as Close } from '../../svg/close.svg';
const ip = process.env.REACT_APP_IP;

function ModalNouvelItem({ isOpen, setOpen, setModif, item, categories,token }) {
    const { fetchPersonnage } = useContext(Context);
    const [nomItem, setNomItem] = useState("");
    const [descriptionItem, setDescriptionItem] = useState("");
    const [effetItem, setEffetItem] = useState("");
    const [valeurItem, setValeurItem] = useState("");
    const [isExclusif, setIsExclusif] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(categories[0]);
    // useEffect(() => {
    //     if (sort) {
    //         setNomSort(sort.nom);
    //         setDescriptionSort(sort.description);
    //         setEffetSort(sort.effet);
    //         setCoutSort(sort.cout);
    //     } else {
    //         setNomSort("");
    //         setDescriptionSort("");
    //         setEffetSort("");
    //         setCoutSort("");
    //     }
    // }, [item]);
    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    //setModif(false)
                    setOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (nomItem === "" || effetItem === "" || descriptionItem === "" || valeurItem === "") {
            console.log("Tous les champs doivent être remplis");
        } else {
            try {
                await axios.post(`${ip}/item`, {
                    nomItem,
                    descriptionItem,
                    effetItem,
                    valeurItem,
                    isExclusif,
                    selectedCategory
                },        {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    } 
                  });
                setNomItem("");
                setDescriptionItem("");
                setEffetItem("");
                setValeurItem("");
                setIsExclusif(false)
                fetchPersonnage();
                setOpen(false);
            } catch (error) {
                console.error('Erreur:', error);
            }
        }
    };


    return (
        <div className="modal-overlay" >
            <div className='modal_flex' ref={wrapperRef}>
                <div className="close" onClick={() => { setOpen(false);/* setModif(false) */  }}>
                    <Close></Close>
                </div>
                <div className="flex">
                    <span className='titleModal margin_1em_LR  padding_1em_top pct-60'>Nom de l'Objet</span>
                    <span className='titleModal margin_1em_LR  padding_1em_top'>Exclusif</span>
                </div>
                <div className="flex">
                    <input
                        type="text"
                        value={nomItem}
                        onChange={e => setNomItem(e.target.value)}
                        placeholder="Nom de l'Onjet"
                        className='titleModal modal_bloc pct-60 border_1px_black input-transparent'
                    />
                    <input type="checkbox"
                        className="margin_1em border_1px_black input-transparent"
                        checked={isExclusif}
                        onChange={e => setIsExclusif(e.target.checked)}
                    />
                </div>
                <span className='titleModal margin_1em_LR pct-90'>Description de l'Objet</span>
                <textarea
                    type="text"
                    value={descriptionItem}
                    onChange={e => setDescriptionItem(e.target.value)}
                    placeholder="Description"
                    className='pct-90 modal_bloc height_10vh border_1px_black input-transparent'
                />

                <span className='titleModal margin_1em_LR pct-90'>Effet de l'Objet</span>
                <input
                    type="text"
                    value={effetItem}
                    onChange={e => setEffetItem(e.target.value)}
                    placeholder="Effet(s)"
                    className='modal-corp pct-90 modal_bloc border_1px_black input-transparent'
                />
                <span className='titleModal margin_1em_LR pct-90'>Categorie de l'Objet</span>
                <select className='pct-90 modal_bloc modal_bloc border_1px_black'
                onChange={e => { setSelectedCategory(categories[e.target.value]) }}
                >
                    {categories.map((category, index) => (
                        <option key={index} value={index}>{category.nomCategorie}</option>
                    ))}
                </select>
                <span className='titleModal margin_1em_LR pct-90'>Valeur de l'Objet (En Bronze)</span>
                <input
                    type="number"
                    value={valeurItem}
                    onChange={e => setValeurItem(e.target.value)}
                    placeholder="Valeur"
                    className='pct-90 modal_bloc modal_bloc border_1px_black input-transparent'
                />

                <button onClick={handleSubmit} className='pct-90 modal_bloc button-large'>Enregistrer</button>
            </div>
        </div>
    );
}

export default ModalNouvelItem;
